import React, { useContext, useEffect, useState } from "react";
import { DarshanBook_TempleList } from "../../ApiServices/Darshan Booking/DarshanBookingApi";
import { Link, useNavigate } from "react-router-dom";
import Batuk from "../../assets/images/new/fav-removebg-preview.png";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import { LoaderContext } from "../../AuthContext/AuthContext";
import Breadcrumbs from "../Breadcrumb";

const DarshanBookingList = () => {
  const [darshanBookingList, setDarshanBookingList] = useState([]);
  const [searchKeyWord, setSearchKeyWord] = useState("");
  const { setLoader, loader } = useContext(LoaderContext);
  useEffect(() => {
    DarshanBookingTempleListData();
  }, []);
  const [searchBtnClick, setSearchClicked] = useState(false);

  useEffect(() => {
    if (searchBtnClick) {
      DarshanBookingTempleListData();
      setSearchClicked(false);
    }
  }, [searchBtnClick]);
  // Filter temples based on search input
  const filteredTemples = darshanBookingList?.filter((temple) =>
    searchKeyWord
      ? temple?.TR_NAME?.toLowerCase().includes(searchKeyWord.toLowerCase())
      : true
  );
  const DarshanBookingTempleListData = async () => {
    const userID = localStorage.getItem("userID") || "";

    const params = {
      START: 0,
      END: 10,
      WORD: "None",
      LATITUDE: "0", // Set to 0 or remove if API allows it
      LONGITUDE: "0", // Set to 0 or remove if API allows it
    };
    setLoader(true);
    const response = await DarshanBook_TempleList(params, userID);

    if (response.ResponseCode === "0" && response.ResponseMessage === "list") {
      const blogs = response?.DATA;
      setLoader(false);
      console.log(blogs, "Fetched temple list without location");
      setDarshanBookingList(blogs);
    }
  };
  const navigate = useNavigate();

  return (
    <div
      style={{ display: "flex", flexDirection: "column" }}
      className="container mt-4 mb-3"
    >
      <div style={{ padding: "8px" }}>
        <Breadcrumbs />
      </div>
      {/* Search Bar */}
      <div className="row mb-3">
        <div className="col-md-6 mx-auto">
          <div
            className="search-box"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flex: "1",
              maxWidth: "100%",
              marginRight: "10px",
              gap: "10px",
            }}
          >
            <input
              type="text"
              className=" custom-search-input"
              placeholder="Search"
              value={searchKeyWord}
              onChange={(e) => setSearchKeyWord(e.target.value)}
            />
            <button
              className="input-group-text text-white"
              style={{ backgroundColor: "#a52444", padding: "8px 15px" }}
              onClick={() => {
                setSearchClicked(true);
              }}
            >
              Search
            </button>
          </div>
        </div>
      </div>

      <div className="row" style={{ justifyContent: "left" }}>
        {filteredTemples.length > 0 ? (
          filteredTemples.map((temple) => (
            <div
              key={temple.TR_ID}
              className="col-lg-3 col-md-6 col-sm-6 product-item-one mb-3"
            >
              <div
                className="card card-shadow-sty shadow-sm bg-white rounded p-2 w-100 d-flex h-100"
                style={{ cursor: "pointer" }}
                onClick={() => navigate(`/temple/${temple.TempleSlug}`)} // you can use `useNavigate` from react-router-dom
              >
                <div className="product-image text-center position-relative">
                  <img
                    src={temple.TR_IMAGE || Batuk}
                    alt={temple.TR_NAME}
                    className="card-img-top"
                    style={{ height: "200px", objectFit: "contain" }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = placeholderImg; // set your fallback image
                    }}
                  />
                </div>

                <div
                  className="product-details text-center d-flex align-item-center justify-content-center flex-column flex-grow-1 p-2"
                  style={{ margin: "0" }}
                >
                  <h6
                    style={{
                      fontSize: "18px",
                      color: "#8f3246",
                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    {temple.TR_NAME}
                  </h6>
                  <div className="prod-details d-flex flex-column h-100">
                    <div>
                      <p className="card-text mb-1">
                        <strong className="text-success">📍</strong>
                        Location: <strong>{temple.TR_ADDRESS}</strong>
                      </p>
                      <p className="card-text mb-2">
                        Darshan Price: <strong>₹ {temple.DARSHAN_PRICE}</strong>
                      </p>
                    </div>

                    <div className="mt-auto">
                      <Link
                        to={`/temple/${temple.TempleSlug}`}
                        style={{
                          color: "#a52444",
                          fontWeight: "500",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "5px",
                        }}
                      >
                        View Details <i className="icon-right-arrow"></i>
                      </Link>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          ))
        ) : !loader ? (
          <div className="d-flex flex-column align-items-center justify-content-center vh-100 text-center">
            <img
              src={Batuk}
              alt="No Services"
              className="img-fluid"
              style={{ maxWidth: "200px" }}
            />
            <h5 className="fw-bold">No Temple available for Darshan</h5>
            <p className="text-muted">Please explore our other categories.</p>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default DarshanBookingList;
